import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Crud} from '@shared/services/crud';
import {AbstractBffApi} from '@models/sharedinterface';
import {ApiFactoryService} from '@shared/services/api-factory.service';
import {AlertService, IAlert} from '@shared/services/alert.service';

@Component({
  template: ''
})
export abstract class AbstractCrudEditComponent implements OnInit {

  protected bffapi: AbstractBffApi;

  form: UntypedFormGroup;

  fields: FormlyFieldConfig[];

  formvalidity: boolean;
  model: any;
  options: FormlyFormOptions;

  entityid: string;
  entityrooturl = '';
  sectionTitle = '';
  buttonTitle = '';
  labelFieldName = 'label';

  createSectionTitle = 'Create entity';
  createButtonTitle = 'Create';
  updatePrefixTitle = 'Edit entity: ';
  updateButtonTitle = 'Update';

  routeIdKeyName = 'id';

  isReady = false;
  isSubmitting = false;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected apifactory: ApiFactoryService,
    protected httpCrud: Crud,
    protected alertService: AlertService
  ) {
    this.bffapi = this.apifactory.createBffApi();

    this.form = new UntypedFormGroup({});

    this.fields = [];

    this.formvalidity = false;

    this.model = {};
  }

  ngOnInit(): void {
    this.entityid = this.activatedRoute.snapshot.paramMap.get(this.routeIdKeyName);

    if (!this.entityid) {
      // Create
      this.sectionTitle = this.createSectionTitle;
      this.buttonTitle = this.createButtonTitle;
      this.getAndConfigureEmptyDynamicFields();
    } else {
      // Update
      this.buttonTitle = this.updateButtonTitle;
      this.getModelAndConfigureDynamicFields(this.entityid);
    } // if
  }

  getAndConfigureEmptyDynamicFields() {
    this.setReady();
  }

  getModelAndConfigureDynamicFields(entityid: string = '') {
    this.httpCrud.getEntity(entityid).subscribe(data => {
      // this.configureStaticFields();
      this.model = data.results;
      this.sectionTitle = `${this.updatePrefixTitle} ${this.model[this.labelFieldName]}`;
      this.setReady();
    });
  }

  onSubmitHandler(): any {
    return () => {
      this.form.markAllAsTouched();
      if (this.form.valid) {
        this.isSubmitting = true;
        if (this.model.id) {
          // edit submit
          this.httpCrud.updateEntity(this.model.id, this.model).subscribe(() => {
            this.isSubmitting = false;
            this.alertService.addAlert({
              type: 'success',
              title: 'Entity updated',
              message: `The entity has been updated successfully`,
            } as IAlert);
          });
        } else {
          // create submit
          this.httpCrud.createEntity(this.model).subscribe(() => {
            this.isSubmitting = false;
            this.router.navigate([this.entityrooturl]).then(() => {
              this.alertService.addAlert({
                type: 'success',
                title: 'New entity created',
                message: `New entity has been created successfully`,
              } as IAlert);
            });
          });
        }
      } else {
        // form not valid
        this.alertService.addAlert({
          type: 'danger',
          title: 'Error',
          message: `Incorrect inputs. Please review the form data.`,
        } as IAlert);
      }
    };
  }

  onCancelHandler(): any {
    return () => this.router.navigate([this.entityrooturl]);
  } // onCancel


  setReady() {
    this.isReady = true;
  }
}
